/* eslint-disable import/prefer-default-export */
export const localStorageKeys = {
  TARGET_PATH: `${process.env.REACT_APP_PROJECT_PHASE === 'PRODUCTION' ? '' : 'dev_'}targetPath`,
  PRIVILEGE: `${process.env.REACT_APP_PROJECT_PHASE === 'PRODUCTION' ? '' : 'dev_'}privilege`,
  NG_TRANS_ID: `${process.env.REACT_APP_PROJECT_PHASE === 'PRODUCTION' ? '' : 'dev_'}NGTransId`,
  CURRENT_USER: `${process.env.REACT_APP_PROJECT_PHASE === 'PRODUCTION' ? '' : 'dev_'}currentUser`,
  JWT_TOKEN: `${process.env.REACT_APP_PROJECT_PHASE === 'PRODUCTION' ? '' : 'dev_'}jwttoken`,
  VERSION: `${process.env.REACT_APP_PROJECT_PHASE === 'PRODUCTION' ? '' : 'dev_'}version`,
  LINE_PARAM: `${process.env.REACT_APP_PROJECT_PHASE === 'PRODUCTION' ? '' : 'dev_'}lineParam`,
  PRE_JWT_TOKEN: `${
    process.env.REACT_APP_PROJECT_PHASE === 'PRODUCTION' ? '' : 'dev_'
  }pre-jwttoken`,
  ACCESS_TOKEN: `${process.env.REACT_APP_PROJECT_PHASE === 'PRODUCTION' ? '' : 'dev_'}access_token`,
};
